const React = require('react');

// Wrapper that provides getSnapshot as a fallback for getServerSnapshot
// when the caller doesn't supply one. Fixes React error #407 during
// hydration from packages (e.g. @carvana/core-auth) that omit it.
exports.useSyncExternalStore = function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
  return React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot || getSnapshot);
};
